<template>
    <div class="scan-ticket-detail">
        <LoadingScreen v-if="isLoadingScreen" />
        <template v-else>
            <h2 class="scan-ticket-detail__title">{{ getTranslatedText('scan ticket') }}</h2>
            <p class="scan-ticket-detail__desciption">{{ getTranslatedText('ticket details') }}</p>
            <div class="scan-ticket-detail__list-table">
                <div class="scan-ticket-detail__table">
                    <span class="scan-ticket-detail__table-title">{{ getTranslatedText('ticket details') }}</span>
                    <div class="scan-ticket-detail__table-item">
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('purchase date') }}</span>
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ renderDate(dataDetail.created_at) }} </span>
                    </div>
                    <div class="scan-ticket-detail__table-item">
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('payment received') }}</span>
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ dataDetail.currency_code }} {{ renderPrice(dataDetail.total || dataDetail.amount) }} </span>
                    </div>
                    <div class="scan-ticket-detail__table-item">
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('ticket') }}</span>
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ ticketId }}</span>
                    </div>
                </div>
                <ItemTickets v-if="ticketType === 'L'" :details="dataSource.details" :events="dataSource.transaction.events" />
                <ItemSports v-else :dataSource="dataSource" />

                <div class="scan-ticket-detail__table-cancel" v-if="dataDetail.cancelations > 0">
                    <span class="scan-ticket-detail__table-item-text_no_upper_all_first">{{ getTranslatedText('Ticket is cancelled') }}</span>
                </div>
                <div class="scan-ticket-detail__table" v-else>
                    <span class="scan-ticket-detail__table-title">{{ Boolean(dataDetail.cancelled) ? getTranslatedText(dataDetail.cancelled_text || 'Ticket is canceled') : getTranslatedText('winnings') }} </span>
                    <div v-if="isCheckShowMakePatment" class="scan-ticket-detail__table-winnings">
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('make payment') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ dataDetail.currency_code }} {{ renderMakePayment() }}<span v-if="freebetTotalQuantity > 0" class="scan-ticket-detail__freebet-note"> &amp; {{ renderPrice(freebetTotalAmount) }} ({{ freebetTotalQuantity }}) {{ getTranslatedText('free spin') }}</span> </span>
                        </div>
                        <div class="scan-ticket-detail__table-winnings-button">
                            <ButtonCommon type="active" :isLoading="isLoadingSettle" :isNoHover="true" :value="isLoadingSettle ? 'settling' : 'settle'" nameFunction="on-call-api-settle" />
                        </div>
                    </div>

                    <div class="scan-ticket-detail__table-empty" v-if="dataDetail.winnings === 0 && dataDetail.cancelations <= 0">
                        <span>{{ getTranslatedText('no winnings') }}</span>
                    </div>

                    <div v-for="(payment, paymentIndex) in payments" :key="paymentIndex" class="scan-ticket-detail__table-payment-list">
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('payment date') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ renderDate(payment.payment_created_at) }} </span>
                        </div>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('amount') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ dataDetail.currency_code }} {{ renderPrice(payment.payment_total) }} </span>
                        </div>
                    </div>
                </div>
                <div class="scan-ticket-detail__table" v-if="ticketType === 'L' && freebetCoupons.length > 0">
                    <span class="scan-ticket-detail__table-title">{{ getTranslatedText('freebet') }}</span>
                    <div class="scan-ticket-detail__table-item-draw" v-for="(coupon, index) in freebetCoupons" :key="index">
                        <hr v-if="index > 0" />
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('freebet amount') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ dataDetail.currency_code }} {{ renderPrice(coupon.freebet_amount) }}</span>
                        </div>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('freebet tickets') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ coupon.freebet_quantity }} / {{ coupon.freebet_quantity_initial }}</span>
                        </div>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('expires at') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ couponExpiryText(coupon) }}</span>
                        </div>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('status') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ couponStatusText(coupon) }}</span>
                        </div>
                        <div class="scan-ticket-detail__table-item" v-if="coupon.printed_at">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('coupon printed') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ renderDate(coupon.printed_at) }}</span>
                        </div>
                        <div class="scan-ticket-detail__freebet-done" v-if="coupon.printed_at">
                            {{ getTranslatedText('done printed') }}
                        </div>
                        <div class="scan-ticket-detail__table-winnings-button scan-ticket-detail__freebet-actions" v-else-if="coupon.status === 'active' && coupon.freebet_quantity > 0 && !couponExpired(coupon)">
                            <ButtonCommon type="active" :isNoHover="true" value="play now" nameFunction="on-play-freebet-coupon" :paramFunction="coupon" />
                            <ButtonCommon type="active" :isNoHover="true" value="print coupon" nameFunction="on-print-freebet-coupon" :paramFunction="coupon" />
                        </div>
                    </div>
                </div>
                <div class="scan-ticket-detail__table" v-if="dataDetail.raffle_details && dataDetail.raffle_details.length > 0">
                    <span class="scan-ticket-detail__table-title">{{ getTranslatedText('raffle') }} </span>
                    <div class="scan-ticket-detail__table-item-draw" v-for="(value, index) in dataDetail.raffle_details" :key="index">
                        <hr v-if="index > 0"/>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('entries of promotion:') }} {{ value.promotion_id }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ value.entry_count }} </span>
                        </div>
                        <div class="scan-ticket-detail__table-empty" v-if="value.no_winnings_message && value.no_winnings_message !== ''">
                            <span style="text-transform: none !important;">{{ getTranslatedText(value.no_winnings_message) }}</span>
                        </div>
                        <div class="scan-ticket-raffle-detail__table" v-if="value.winnings && value.winnings.length > 0">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{{ getTranslatedText('Win Tier') }}</th>
                                        <th>{{ getTranslatedText('Prize') }}</th>
                                        <th>{{ getTranslatedText('Paid At') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(w, i) in value.winnings" :key="i">
                                        <td>{{ w.tier }}</td>
                                        <td>{{ value.prize_type_slug === 'monetary' ? renderPrice(w.winnings) : w.winnings }}</td>
                                        <td>{{ w.paid_at ? renderDate(w.paid_at, true) : '' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="!value.allow_cashier_to_pay && dataDetail.cashier_is_allowed_to_pay_raffle_promotion" class="scan-ticket-detail__table-winnings-button">
                                <ButtonCommon type="active" :value="getTranslatedText('contact lonagui')" />
                            </div>
                        </div>
                    </div>
                    <div v-if="dataDetail.cashier_is_allowed_to_pay_raffle_promotion && dataDetail.unpaid_raffle_winnings && dataDetail.unpaid_raffle_winnings > 0" class="scan-ticket-detail__table-winnings">
                        <hr/>
                        <div class="scan-ticket-detail__table-item">
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('make raffle payment') }}</span>
                            <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ dataDetail.currency_code }} {{ raffleUnpaidAmount() }} </span>
                        </div>
                        <div class="scan-ticket-detail__table-winnings-button">
                            <ButtonCommon type="active" :isLoading="isLoadingSettle" :isNoHover="true" :value="isLoadingSettle ? 'settling' : 'settle'" nameFunction="on-call-api-settle-raffle" />
                        </div>
                    </div>
                    <div v-if="!dataDetail.cashier_is_allowed_to_pay_raffle_promotion 
                            && ((dataDetail.unpaid_raffle_winnings && dataDetail.unpaid_raffle_winnings > 0)
                            || dataDetail.have_non_money_raffle_winnings)" class="scan-ticket-detail__table-winnings-button">
                        <hr style="margin-top: 0;"/>
                        <ButtonCommon type="active" :value="getTranslatedText('contact lonagui')" />
                    </div>
                </div>
            </div>
        </template>

        <v-dialog persistent v-model="dialogSettle" width="100%">
            <v-card class="scan-ticket-detail__box-modal">
                <div class="scan-ticket-detail" v-if="printData">
                    <span class="scan-ticket-detail__box-modal-title">{{ getTranslatedText('ticket details') }}</span>
                    <div class="scan-ticket-detail__table-item">
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('payment date') }}</span>
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value"> {{ renderDate(printData.date, true) }} </span>
                    </div>
                    <div class="scan-ticket-detail__table-item">
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-label">{{ getTranslatedText('amount') }}</span>
                        <span class="scan-ticket-detail__table-item-text scan-ticket-detail__column-value">{{ dataDetail.currency_code }} {{ renderPrice(printData.winnings) }} </span>
                    </div>
                    <div class="scan-ticket-detail__table-modal-button">
                        <ButtonCommon type="active" className="btn-close-modal" :isNoHover="true" value="close" nameFunction="on-cancel-modal-settle" />
                        <ButtonCommon type="active" className="btn-print-modal" :isNoHover="true" value="print" nameFunction="on-print-settle" />
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <CouponPrintStatus />
    </div>
</template>
<script>
import EventBus from '@/utils/EventBus'
import BetslipsService from '@/services/betslip.service'
import languageMixins from '@/mixins/language/language-mixins'
import printMixins from '@/mixins/print/print-mixin'
import ItemTickets from '@/components/ScanTicket/item/ticket.vue'
import ItemSports from '@/components/ScanTicket/item/sport.vue'
import RadioCommon from '@/components/common/radio/index.vue'
import LoadingScreen from '@/components/common/loading/index.vue'
import ButtonCommon from '@/components/common/button/index.vue'
import CouponPrintStatus from '@/components/common/dialog/coupon-print-status.vue'

import { formatDateUTC00, formatPrice, isObjEmpty } from '@/utils/utils'

export default {
    mixins: [languageMixins, printMixins],
    components: { RadioCommon, LoadingScreen, ItemTickets, ItemSports, ButtonCommon, CouponPrintStatus },
    props: {
        dataSource: {
            type: Object,
            default: () => {},
        },
        ticketId: {
            type: String,
            default: '',
        },
        ticketType: {
            type: String,
            default: '',
        },
        detailByScanner: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoadingScreen: true,
            payments: null,
            isCheckShowMakePatment: false,
            dataDetail: null,
            printData: null,
            isLoadingSettle: false,
            dialogSettle: false,
            settleRaffle: false
        }
    },
    computed: {
        freebetCoupons() {
            return this.dataSource && Array.isArray(this.dataSource.freebet_coupons)
                ? this.dataSource.freebet_coupons
                : []
        },
        freebetTotalAmount() {
            return this.dataSource && this.dataSource.freebet_total_amount
                ? parseFloat(this.dataSource.freebet_total_amount)
                : 0
        },
        freebetTotalQuantity() {
            return this.dataSource && this.dataSource.freebet_total_quantity
                ? parseInt(this.dataSource.freebet_total_quantity, 10)
                : 0
        },
    },
    created() {
        this.fetchData()
        EventBus.$on('on-call-api-settle', () => this.settleTicket())
        EventBus.$on('on-call-api-settle-raffle', () => this.settleRaffleTicket())
        EventBus.$on('on-cancel-modal-settle', () => {
            this.dialogSettle = false
            this.onSearchTicketDetail()
        })
        EventBus.$on('on-print-settle', () => this.onPrintSettle())
        EventBus.$on('on-print-freebet-coupon', (coupon) => this.printCoupon(coupon))
        EventBus.$on('on-play-freebet-coupon', (coupon) => this.playCoupon(coupon))
        // After a successful coupon print, the coupon is stamped printed_at
        // retail-side — re-fetch so the row flips to "Coupon Printed" + Reprint.
        EventBus.$on('on-coupon-printed', () => this.onSearchTicketDetail())
    },
    destroyed() {
        EventBus.$off('on-call-api-settle-raffle')
        EventBus.$off('on-call-api-settle')
        EventBus.$off('on-cancel-modal-settle')
        EventBus.$off('on-print-settle')
        EventBus.$off('on-print-freebet-coupon')
        EventBus.$off('on-play-freebet-coupon')
        EventBus.$off('on-coupon-printed')
    },
    methods: {
        // Whether the scanned ticket's winnings payout window has lapsed (computed
        // API-side, mirrors lotto_betslip_payout). An expired ticket expires its
        // FreeBet coupon too.
        ticketWinningsExpired() {
            return !!(this.dataSource && this.dataSource.winnings_expired)
        },
        // Effective coupon expiry, mirroring the API:
        //  - anchored (printed/claimed): expired once expires_at passes;
        //  - never anchored: no expiry of its own, but dies with the source ticket.
        couponExpired(coupon) {
            if (!coupon) return false
            if (coupon.status === 'expired') return true
            if (coupon.status !== 'active') return false
            if (coupon.expires_at) {
                return new Date(coupon.expires_at).getTime() < Date.now()
            }
            return this.ticketWinningsExpired()
        },
        // "NA" until the clock is anchored; the real date once it is; "expired" when the
        // source ticket lapsed before any print/claim.
        couponExpiryText(coupon) {
            if (coupon && coupon.expires_at) return this.renderDate(coupon.expires_at)
            if (this.couponExpired(coupon)) return this.getTranslatedText('expired')
            return 'NA'
        },
        couponStatusText(coupon) {
            return this.getTranslatedText(this.couponExpired(coupon) ? 'expired' : (coupon ? coupon.status : ''))
        },
        showNotification(text, type) {
            const param = {
                text: text,
                type: type,
            }
            EventBus.$emit('show-notications', param)
        },

        async onSearchTicketDetail() {
            this.isLoadingScreen = true
            try {
                const response = await BetslipsService.searchBetslip(this.ticketId)

                this.dataSource = response.data
                this.fetchData()
            } catch (error) {
                console.log(error)
            }
        },

        fetchData() {
            let dataDetail = this.ticketType === 'L' ? this.dataSource.transaction : this.dataSource.details
            if (this.ticketType === 'S') dataDetail['paid'] = 0

            let isCheckWinnings = parseFloat(dataDetail.winnings) > 0 && parseFloat(dataDetail.winnings) > parseFloat(dataDetail.paid) + parseFloat(dataDetail.payments)
            let isCheckCancelations = parseFloat(dataDetail.cancelations) > 0 && parseFloat(dataDetail.cancelations) > parseFloat(dataDetail.paid) + parseFloat(dataDetail.payments)
            if (isCheckWinnings || isCheckCancelations) {
                this.isCheckShowMakePatment = true
            } else {
                this.isCheckShowMakePatment = false
            }

            if (this.ticketType === 'L') {
                // Build the flat payments list across all bets.
                // New API shape: each bet detail row may carry a `payments_list` array
                // (one entry per payout transaction — original + each partial top-up).
                // Old API shape: fall back to the per-bet single-payment row using
                // payment_total + payment_created_at.
                let allPayments = []
                this.dataSource.details.forEach((bet) => {
                    if (Array.isArray(bet.payments_list) && bet.payments_list.length > 0) {
                        bet.payments_list.forEach((p) => {
                            allPayments.push({
                                payment_created_at: p.created_at,
                                payment_total: p.amount,
                                payment_type: p.type,
                                payment_reference: p.reference,
                                transaction_id: p.transaction_id,
                            })
                        })
                    } else if (bet.payment_total && bet.payment_total > 0) {
                        allPayments.push({
                            payment_created_at: bet.payment_created_at,
                            payment_total: bet.payment_total,
                            payment_type: 'original',
                            payment_reference: bet.payment_reference,
                            transaction_id: bet.payout_transaction_id,
                        })
                    }
                })
                allPayments.sort((a, b) => new Date(a.payment_created_at) - new Date(b.payment_created_at))
                this.payments = allPayments
                this.isLoadingScreen = false
            }
            if (this.ticketType === 'S') {
                if (dataDetail.payments > 0) {
                    const payments = [
                        {
                            payment_created_at: dataDetail.paid_date,
                            payment_total: dataDetail.payments,
                        },
                    ]

                    this.payments = payments
                }
                this.isLoadingScreen = false
            }
            this.dataDetail = dataDetail
        },

        async settleTicket() {
            this.isLoadingSettle = true
            try {
                let raffle = this.settleRaffle
                this.settleRaffle = false
                const response = await BetslipsService.settleBetslip(this.ticketId, raffle, this.detailByScanner)
                this.settleRaffle = false
                if (response.status === 200) {
                    this.printData = response.data
                    this.dialogSettle = true
                    this.isLoadingSettle = false
                } else {
                    this.showNotification(response.message, 'error')
                    this.isLoadingSettle = false
                }
            } catch (error) {
                console.log(error)
            }
        },

        async settleRaffleTicket() {
            this.settleRaffle = true
            return this.settleTicket()
        },

        onPrintSettle() {
            let param = this.printData
            this.printSettle(param)
            this.dialogSettle = false
            this.onSearchTicketDetail()
        },

        printCoupon(coupon) {
            // Route through the isolated coupon-print dialog so the print goes
            // through the same device handshake (print-status ack) the transact
            // path uses, with a reprint prompt if the printer fails — instead of
            // firing a raw postMessage that silently drops when the printer is busy.
            EventBus.$emit('on-show-coupon-print', {
                ...coupon,
                currency_code: this.dataDetail ? this.dataDetail.currency_code : '',
                source_ticket_id: this.ticketId,
            })
        },

        playCoupon(coupon) {
            const remaining = parseInt(coupon.freebet_quantity, 10) || 0
            if (!coupon.code || remaining <= 0) {
                this.showNotification(this.getTranslatedText('coupon not valid'), 'error')
                return
            }
            // A freebet play takes over the Loto 5/90 betslip (the placement must be an
            // all-Boost transact). Clear any pending 5/90 bets automatically so the
            // freebet basket starts clean, then move forward. Other games' betslips
            // are separate and untouched.
            this.$store.state.stepCart = 1
            this.$store.dispatch('onClearCart')
            this.$store.commit('SET_FREEBET_CONTEXT', {
                code: coupon.code,
                remaining: remaining,
                amount: parseFloat(coupon.freebet_amount) || 0,
                category: coupon.boost_category || null,
            })
            this.$router.push('/loto')
        },

        renderMakePayment() {
            const price = parseFloat(this.dataDetail.winnings) + parseFloat(this.dataDetail.cancelations) - (parseFloat(this.dataDetail.paid) + parseFloat(this.dataDetail.payments))
            return formatPrice(price)
        },

        raffleUnpaidAmount() {
            return formatPrice(this.dataDetail.unpaid_raffle_winnings)
        },

        renderDate(date, isShowTime) {
            const dateFormat = formatDateUTC00(date)

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`

            return valueDate
        },

        renderPrice(price) {
            return formatPrice(price)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/scan-ticket/_detail.scss';

.scan-ticket-detail__freebet-note {
    display: inline-block;
    white-space: nowrap;
    color: #b07a00;
    font-weight: 600;
}

.scan-ticket-detail__freebet-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .btn,
    button {
        flex: 1;
        min-width: 140px;
    }
}

.scan-ticket-detail__freebet-done {
    margin-top: 8px;
    text-align: center;
    font-weight: 700;
    color: #1a7f37;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
</style>
